import { useEffect, useState } from 'react';
import './Patents.css';
import { getPatentApplications } from '../../utilities/api/patentApplications';
import PatentApplicationsList from '../../components/PatentApplicationsList/PatentApplicationsList';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

export default function Patents({ user, isMobile }) {
  const [loading, setLoading] = useState(false)
  const [patentApplications, setPatentApplications] = useState([])
  const [patentSortOrder, setPatentSortOrder] = useState('desc')
  const [patentSortHeader, setPatentSortHeader] = useState('createdAt')


  const getApplications = async () => {
    setLoading(true)
    try {
      const allPatentApplications = await getPatentApplications(user)
      setPatentApplications(allPatentApplications.sort((a, b) => a[patentSortHeader] < b[patentSortHeader] ? 1 : -1))
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  const updatePatentApplications = (updatedData) => {
    updatedData.sort((a, b) => {
      if (patentSortOrder === 'asc') {
          return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) > (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
      } else {
          return ((typeof(a[patentSortHeader])==='string' ? a[patentSortHeader].toLowerCase() : a[patentSortHeader]) < (typeof(b[patentSortHeader])==='string' ? b[patentSortHeader].toLowerCase() : b[patentSortHeader])) ? 1 : -1
      }
    });
    setPatentApplications(updatedData)
  }

  useEffect(() => {
    getApplications()
    // eslint-disable-next-line
  },[])

  return (
    <div className='Patents'>
      <div className='applicationsHeadingContainer'>
        <div className='headerContent'>
            <img src='https://project-intake-assets.s3.ca-central-1.amazonaws.com/Skin.png' alt="" />
            <div className='mainHeaderContent'>
                <div className='companyName'>
                    {capitalizeFirstLetter(user.companyName)}
                </div>
                <div className='instructions'>
                    Below is a list of all your <strong>Patent Applications</strong>.
                </div>
            </div>
        </div>
      </div>
      { loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='applicationsMainSection'>
        {(patentApplications && patentApplications.length === 0) ?
        <div className='emptyList'>
          <div className='text-center'>
              <h4 className='errorText pt-3'>No Patent Applications</h4>
          </div>
        </div>
        :
        <PatentApplicationsList 
          user={user} 
          patentApplications={patentApplications}
          updatePatentApplications={updatePatentApplications}
          sortHeader={patentSortHeader} 
          setSortHeader={setPatentSortHeader}
          sortOrder={patentSortOrder}
          setSortOrder={setPatentSortOrder}
          isMobile={isMobile} />
        }
        </div>
      }
    </div>
  )
}
